export const landingMessages = {
  en: {
    header: {
      link: "Home",
      linkServices: "Services",
      linkPlatform: "Software",
      linkUs: "About Us",
      linkLogin: "Login",
      LinkRegister: "Register"
    },
    hero: {
      title: "Inspiring Better Hedging Decisions",
      subtitle:
        "Powerful, intuitive, and effective hedge management at your fingertips.",
      trial: "Start Free",
      demo: "Request a Demo",
      highlight1: "Secure data",
      highlight2: "Deeper insights",
      highlight3: "Clearer reporting",
      highlight4: "Smarter risk control"
    },
    products: {
      title: "Next-Generation Risk Management",
      prods: [
        {
          title: "Advisory Services",
          text:
            "Our seasoned experts bring unparalleled expertise to craft and optimize hedging programs. We deliver tailored solutions that strike the perfect balance between cash flow stability, balance sheet protection, and sustained profitability—keeping your business ahead of the curve.",
          image: require("@/assets/images/meeting1.jpeg")
        },
        {
          title: null,
          text:
            "QUANSPIRE transforms hedging with speed and precision. Access critical market insights, visualize your full portfolio of exposures and hedges, and simulate strategies effortlessly for smarter, faster decisions.",
          image: require("@/assets/images/platformFront.png")
        },
        {
          title: "Hedging Desk",
          text:
            "Beyond our cutting-edge platform, we offer hands-on financial expertise—executing hedging programs, designing and valuing strategies, and providing real-time market analysis to fuel your decision-making.",
          image: require("@/assets/images/platform.jpg")
        }
      ]
    },
    platform: {
      title: "A Smarter Way to Manage Risk",
      subtitle: "Discover how we simplify and optimize your hedging decisions.",
      items: [
        {
          title: "Data Security",
          text: "Organize, protect, and leverage your data for better insights."
        },
        {
          title: "Digital Oversight",
          text: "Monitor and control your hedging strategies anytime, anywhere."
        },
        {
          title: "24/7 Accessibility",
          text: "Always available when you need it most."
        },
        {
          title: "Enhanced Reporting",
          text: "Gain clarity and communicate results effectively."
        },
        {
          title: "Smarter Decisions",
          text: "Analyze real-time alternatives for better outcomes."
        }
      ]
    },
    aboutUs: {
      paragraph1:
        "Launched with seed funding in 2019, QUANSPIRE is a digital innovator born to empower companies—importers, exporters, producers, and buyers—with tools to master currency and commodity risk.",
      paragraph2:
        "Our flagship platform, QUANSPIRE, redefines hedging by simplifying complex decisions with precision and speed.",
      paragraph3:
        "Built on proprietary mathematical algorithms, QUANSPIRE is backed by a team with deep expertise from working with leading Colombian firms and multinationals across Latin America and the USA.",
      paragraph4:
        "Seamlessly integrating cash flows, balance sheet exposures, and hedges with real-time market data, QUANSPIRE leverages AI-driven analytics and powerful algorithms to optimize your strategies like never before."
    },
    footer: {
      about: "We are",
      title: "Hedging Desk",
      tel: "(+571) 523 1000",
      address: "Carrera 13 No 96 - 82, Of. 401 and 405,",
      city: "Bogotá, Colombia",
      offices: "Our Offices",
      copyright: "© 2025 QUANSPIRE. All rights reserved."
    },
    demo: {
      title: "Request Your Demo",
      firstName: "First Name",
      lastName: "Last Name",
      company: "Company",
      email: "Email",
      phone: "Phone (optional)",
      submit: "Submit Request",
      toastSucces: {
        title: "Success",
        message: "Your request has been sent successfully."
      },
      toastError: {
        title: "Error",
        message: "There was an error sending your request."
      }
    }
  },
  es: {
    header: {
      link: "Inicio",
      linkServices: "Servicios",
      linkPlatform: "Plataforma",
      linkUs: "Nosotros",
      linkLogin: "Iniciar Sesión",
      LinkRegister: "Registrarse"
    },
    hero: {
      title: "Inspirando Mejores Decisiones de Cobertura",
      subtitle: "Gestión de coberturas intuitiva, efectiva y poderosa.",
      trial: "Comienza Gratis",
      demo: "Solicitar Demo",
      highlight1: "Datos seguros",
      highlight2: "Mayor profundidad",
      highlight3: "Reportes claros",
      highlight4: "Gestión de riesgo optimizada"
    },
    products: {
      title: "La Nueva Era de la Gestión de Riesgo",
      prods: [
        {
          title: "Asesoría Especializada",
          text:
            "Nuestro equipo experto diseña y optimiza estrategias de cobertura para equilibrar riesgos financieros y mantener la rentabilidad y competitividad de tu empresa.",
          image: require("@/assets/images/meeting1.jpeg")
        },
        {
          title: "Análisis Avanzado",
          text:
            "QUANSPIRE mejora y agiliza la toma de decisiones, brindando datos clave del mercado y permitiendo visualizar y simular el portafolio completo de exposiciones y coberturas.",
          image: require("@/assets/images/platformFront.png")
        },
        {
          title: "Mesa de Coberturas",
          text:
            "Además de nuestra plataforma avanzada, ofrecemos soporte financiero en la ejecución de estrategias de cobertura, diseño de estrategias óptimas y análisis de mercado para una mejor toma de decisiones.",
          image: require("@/assets/images/platform.jpg")
        }
      ]
    },
    platform: {
      title: "Software de Gestión de Riesgo Reinventado",
      subtitle: "Descubre cómo simplificamos y potenciamos tus decisiones.",
      items: [
        {
          title: "Seguridad de Datos",
          text:
            "Organiza, protege y aprovecha tus datos para mejores decisiones."
        },
        {
          title: "Gestión Digital",
          text: "Controla tus coberturas en cualquier momento y lugar."
        },
        {
          title: "Disponibilidad 24/7",
          text: "Siempre estamos contigo cuando nos necesitas."
        },
        {
          title: "Comunica Mejor",
          text: "Presenta tus resultados con claridad y precisión."
        },
        {
          title: "Decisiones Más Inteligentes",
          text: "Evalúa múltiples opciones en tiempo real."
        }
      ]
    },
    aboutUs: {
      paragraph1:
        "QUANSPIRE nació en 2019 como una startup digital financiada en su primera ronda de inversión. Su misión: ofrecer a empresas—importadoras, exportadoras, productores y compradores—una solución efectiva para gestionar riesgos en monedas y materias primas.",
      paragraph2:
        "Nuestra plataforma analítica QUANSPIRE simplifica y acelera las decisiones de cobertura con tecnología de punta.",
      paragraph3:
        "Desarrollada con algoritmos matemáticos propietarios, QUANSPIRE cuenta con un equipo experto que ha trabajado con grandes empresas colombianas y multinacionales en Latam y EE. UU., optimizando programas de cobertura.",
      paragraph4:
        "Integra flujos de caja, exposiciones de balance y coberturas con datos de mercado en tiempo real. Potenciada por inteligencia artificial y algoritmos avanzados, optimiza tus estrategias de cobertura como nunca antes."
    },
    footer: {
      about: "Somos",
      title: "Mesa de Coberturas",
      tel: "(+571) 523 1000",
      address: "Carrera 13 No 96 - 82, Oficina 401 y 405,",
      city: "Bogotá, Colombia",
      offices: "Nuestras Oficinas",
      copyright: "© 2026 QUANSPIRE. Todos los derechos reservados."
    },
    demo: {
      title: "Solicita tu Demo",
      firstName: "Nombre",
      lastName: "Apellido",
      company: "Compañía",
      email: "Email",
      phone: "Teléfono (opcional)",
      submit: "Enviar Solicitud",
      toastSucces: {
        title: "Éxito",
        message: "Tu solicitud ha sido enviada con éxito."
      },
      toastError: {
        title: "Error",
        message: "Hubo un error al enviar tu solicitud."
      }
    }
  }
};
